import withAuthServerSideProps from '@/libs/auth';
import ReelListLayout from '@/features/reels';

import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { KeyActive, PageLayout } from '@/layouts/shared';
import { getSelectorsByUserAgent } from 'react-device-detect';

const ReelListPage = () => {
  return <ReelListLayout />;
};

export const getServerSideProps = withAuthServerSideProps(
  async ({ locale, req }: GetServerSidePropsContext) => {
    const { isMobile } = getSelectorsByUserAgent(req.headers['user-agent'] as string);

    return {
      props: {
        layout: PageLayout.New,
        keyActive: KeyActive.Reels,
        isMobile,
        ...(await serverSideTranslations(locale as string, ['reel', 'layout'])),
      },
    };
  },
  { isAntiAuth: false, isPublic: true }
);

export default ReelListPage;
